export type RouteName =
  | "landing"
  | "tickets"
  | "ticketsPrevious"
  | "event"
  | "about"
  | "login"
  | "app"
  | "owner"
  | "scanner"
  | "doorTickets"
  | "checkoutSuccess"
  | "checkoutCancel"
  | "ticket"
  | "notFound";

export function getRoute(pathname: string): { name: RouteName; slug?: string; appPath?: string; ownerPath?: string; ticketCode?: string } {
  const normalizedPathname = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

  if (normalizedPathname === "/") return { name: "landing" };
  if (normalizedPathname === "/events" || normalizedPathname === "/tickets") return { name: "tickets" };
  if (normalizedPathname === "/tickets/previous") return { name: "ticketsPrevious" };
  if (normalizedPathname === "/about") return { name: "about" };
  if (normalizedPathname.startsWith("/e/")) return { name: "event", slug: normalizedPathname.slice(3) || "neon-rooftop" };
  if (normalizedPathname === "/checkout/success") return { name: "checkoutSuccess" };
  if (normalizedPathname === "/checkout/cancel") return { name: "checkoutCancel" };
  if (normalizedPathname.startsWith("/t/")) return { name: "ticket", ticketCode: normalizedPathname.slice(3) };
  if (normalizedPathname === "/login") return { name: "login" };
  if (normalizedPathname === "/app" || normalizedPathname.startsWith("/app/")) return { name: "app", appPath: normalizedPathname };
  if (normalizedPathname === "/owner" || normalizedPathname.startsWith("/owner/")) return { name: "owner", ownerPath: normalizedPathname };
  if (normalizedPathname === "/scanner") return { name: "scanner" };
  if (normalizedPathname === "/scanner/tickets") return { name: "doorTickets" };
  return { name: "notFound" };
}
